/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get the largest, highest-quality thumbnail a video offers — up to 1280×720 (maxresdefault). Paste a YouTube link to grab the full-size HD image.`)
};

const es_yt_hd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtén la miniatura más grande y de mayor calidad que ofrece un video — hasta 1280×720 (maxresdefault). Pega un enlace de YouTube para obtener la imagen HD a tamaño completo.`)
};

const de_yt_hd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hol dir das größte und hochwertigste Thumbnail, das ein Video bietet — bis zu 1280×720 (maxresdefault). Füge einen YouTube-Link ein, um das HD-Bild in voller Größe zu erhalten.`)
};

const nl_yt_hd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krijg de grootste, best mogelijke thumbnail die een video biedt — tot 1280×720 (maxresdefault). Plak een YouTube-link om de HD-afbeelding op volledig formaat te downloaden.`)
};

const fr_yt_hd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenez la miniature la plus grande et la plus qualitative qu’une vidéo propose — jusqu’à 1280×720 (maxresdefault). Collez un lien YouTube pour récupérer l’image HD en taille réelle.`)
};

const it_yt_hd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottieni la miniatura più grande e di qualità più alta offerta da un video — fino a 1280×720 (maxresdefault). Incolla un link YouTube per ottenere l'immagine HD a piena dimensione.`)
};

const pt_br2_yt_hd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegue a thumbnail maior e de melhor qualidade que um vídeo oferece — até 1280×720 (maxresdefault). Cole um link do YouTube para baixar a imagem HD em tamanho completo.`)
};

const pt_yt_hd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obtenha a miniatura maior e de maior qualidade que um vídeo oferece — até 1280×720 (maxresdefault). Cole um link do YouTube para obter a imagem HD em tamanho completo.`)
};

const ja_yt_hd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動画が提供する最大・最高画質のサムネイル — 最大1280×720（maxresdefault）を取得できます。YouTubeのリンクを貼り付けて、フルサイズのHD画像を手に入れましょう。`)
};

const zh_yt_hd_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取视频提供的最大、画质最高的缩略图 — 最高可达 1280×720（maxresdefault）。粘贴 YouTube 链接即可获取全尺寸 HD 图片。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hd_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hd_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hd_intro", locale)
	if (locale === "en") return en_yt_hd_intro(inputs)
	if (locale === "es") return es_yt_hd_intro(inputs)
	if (locale === "de") return de_yt_hd_intro(inputs)
	if (locale === "nl") return nl_yt_hd_intro(inputs)
	if (locale === "fr") return fr_yt_hd_intro(inputs)
	if (locale === "it") return it_yt_hd_intro(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hd_intro(inputs)
	if (locale === "pt") return pt_yt_hd_intro(inputs)
	if (locale === "ja") return ja_yt_hd_intro(inputs)
	return zh_yt_hd_intro(inputs)
};